import angular from 'angular';
import { routes } from './relatorios.routes';
import LmeDetailRelatoriosController from "./details/details.controller";
import LmeDirectoryRelatoriosController from "./directory/directory.controller";
export default angular.module('app.laboratory.relatorios', [])
    .config(routes)
    .controller('LmeDetailRelatoriosController', LmeDetailRelatoriosController)
    .controller('LmeDirectoryRelatoriosController', LmeDirectoryRelatoriosController)
    .name;
